// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Loader_overlay__3L9d8"};